<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha v-if="!loading" style="min-height: 76px">
      <unicom-coluna sm="auto">
        <div class="segunda-cor-fonte">Código</div>
        <div class="codigo-unimed mt-3">
          {{ zeroEsquerda(objetoInformacoes.codigoUnimed, 3) }}
        </div>
      </unicom-coluna>
      <unicom-coluna
        sm="12"
        md="auto"
        style="width: calc(100% - 600px)"
        :class="{
          'mt-4': $breakpoint.smAndDown
        }"
      >
        <div class="segunda-cor-fonte">Nome</div>
        <div class="titulo negrito mt-3" v-if="nomeUnimed.length < 40">
          {{ nomeUnimed }}
        </div>
        <unicom-tooltip
          v-else
          tooltipLocalizacao="top"
          :whiteSpaceNoWrap="false"
          :textoTooltip="nomeUnimed"
        >
          <div slot="itemTooltip" class="titulo negrito mt-3 text-overflow">
            {{ nomeUnimed }}
          </div>
        </unicom-tooltip>
        <div class="pt-1">
          <div v-if="mostrarAdicionarObservacao">
            Sem observações.
            <span
              class="cor-principal text-underline"
              @click="$emit('adicionar-observacao')"
            >
              Adicione</span
            >
            uma nova observação.
          </div>
          <div v-else>
            Existem {{ zeroEsquerda(quantidadeObservacoes, 2) }}
            <span
              class="cor-principal text-underline"
              @click="$emit('mostrar-observacao')"
            >
              {{ quantidadeObservacoes > 1 ? "observações" : "observação" }}
            </span>
            registradas.
          </div>
        </div>
      </unicom-coluna>
      <unicom-coluna
        sm="12"
        md="auto"
        :class="{
          'ml-auto': !$breakpoint.smAndDown,
          'mt-4': $breakpoint.smAndDown
        }"
        v-if="mostrarAnalista"
      >
        <div class="segunda-cor-fonte">Analista responsável</div>
        <div style="min-height: 35px" class="mt-3">
          <div class="medio negrito">
            {{ objetoInformacoes.analistaResponsavel }}
          </div>
          <div class="mt-1">{{ objetoInformacoes.emailResponsavel }}</div>
        </div>
      </unicom-coluna>
      <unicom-coluna
        sm="12"
        md="auto"
        :class="{
          'ml-auto': !mostrarAnalista
        }"
        style="height: 64.8px"
      >
        <unicom-linha style="height: 100%">
          <unicom-coluna alinhamento="start" sm="12" md="auto">
            <div class="segunda-cor-fonte mb-3" v-if="!mostrarAnalista">
              Unimed sem analista
            </div>
            <unicom-botao
              v-if="
                mostrarBotaoAdicionar && objetoInformacoes.podeEditarAnalistas
              "
              :bloco="$breakpoint.smAndDown"
              :largura="178"
              @click="$emit('abrir-modal')"
            >
              ADICIONAR ANALISTA
            </unicom-botao>
            <unicom-botao
              v-else-if="objetoInformacoes.podeEditarAnalistas"
              :bloco="$breakpoint.smAndDown"
              :largura="178"
              @click="$emit('abrir-modal')"
            >
              EDITAR ANALISTA
            </unicom-botao>
          </unicom-coluna>
        </unicom-linha>
      </unicom-coluna>
    </unicom-linha>
    <div v-else>
      <unicom-spinner
        style="min-height: 76px; display: flex; align-items: center"
        v-show="loading"
        :tamanhoLoading="62"
        :tamanhoLinha="7"
        :velocidade="0.5"
        :marginTopTexto="30"
      />
    </div>
  </unicom-layout-cartao>
</template>

<script>
export default {
  props: {
    objetoInformacoes: {
      type: Object,
      default: () => {
        return {
          codigoUnimed: null,
          nomeUnimed: null,
          analistaResponsavel: null,
          emailResponsavel: null,
          podeEditarAnalistas: false
        };
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    quantidadeObservacoes: {
      type: Number,
      default: 0
    }
  },
  computed: {
    mostrarAnalista() {
      return !["", null, undefined].includes(
        this.objetoInformacoes.analistaResponsavel
      );
    },
    mostrarBotaoAdicionar() {
      return !this.mostrarAnalista;
    },
    mostrarAdicionarObservacao() {
      return this.quantidadeObservacoes <= 0;
    },
    nomeUnimed() {
      return this.pegaNomeTextoExibicao(this.objetoInformacoes.nomeUnimed);
    }
  }
};
</script>

<style lang="scss" scoped>
.titulo-unimed {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
